import { selectLaunchableJourneyIdsSorted } from '../selectors/config'
import type { JourneyHydratedAction } from '../types/actions'
import { APP_STATUS } from '../types/enums'

import { actionFactory } from './factory'
import { featureFlagsChanged } from './featureFlagsChanged'
import { journeyChanged } from './journeyChanged'

export const journeyHydrated = actionFactory<JourneyHydratedAction>(
  (state, { response, diferentiator }) => {
    // wont proceed if the app has permanently failed
    if (state.appStatus === APP_STATUS.FAILED) return

    const { featureFlags, ...journey } = response

    journeyChanged({ journey }, state)
    featureFlagsChanged({ featureFlags }, state)

    if (diferentiator === 'root') {
      state.rootJourneyId = journey.journeyId

      const firstLaunchable = selectLaunchableJourneyIdsSorted(state)[0]

      // selects the first launchable or this journey
      state.selectedJourneyId = firstLaunchable ?? journey.journeyId

      state.appStatus = APP_STATUS.READY
    }
  },
  'journeyHydrated'
)
